import React, { Component } from 'react';

export default class ResultError extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null
    };
  }
  render() {
    let {T} = this.props
    return (
      <div className="error-box">
        <div className="title">
          <T.span text={{key:"error-box-title"}}/>
        </div>
        <div className="error-text">
          {this.props.list && this.props.list.map(function(listValue, listIndex){
            const itemKey = 'key-' + listIndex;
            return <p key={itemKey}>{listValue}</p>;
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/result/error.js